import { useSelector } from 'react-redux';

import {
  selectFilterData,
  selectFilterCriteriaData
} from 'pages/TeamSchedule/ExternalTrainings/selectors';

export function useTrainingsSelector() {
  const filter = useSelector(selectFilterData());
  const filterCriteria = useSelector(selectFilterCriteriaData());

  return {
    filter,
    filterCriteria
  };
}
